// Страж разделов: закрывает страницу, если её пункт скрыт настройкой в админке
// («Настройки → Меню», backend/app/services/nav_visibility.py).
//
// Скрыть пункт мало — по прямой ссылке раздел остался бы открытым (владелец,
// 10.09). Страж один на всё приложение и определяет раздел по адресу, а не по
// обёрткам вокруг каждого маршрута: подпути вроде /bots/video/tool/:slug
// закрываются сами, и правка не трогает таблицу маршрутов.
//
// Сотрудник заходит всегда: режим 'off' убирает раздел у клиентов, но оставляет
// владельцу возможность его открыть и проверить. Пока карта режимов не пришла
// или запрос упал — не мешаем: страж только запрещает, а не открывает.
import { useLocation, Navigate } from 'react-router-dom'
import { navMode, navVisible } from '../api/nav'
import { publicUnderSection, sectionIdForPath } from '../utils/navSection'
import { useAuth } from '../context/AuthContext'
import { useNavModes } from '../hooks/useNavModes'
import { isStaff } from '../utils/roles'

export default function NavRouteGuard() {
	const { pathname } = useLocation()
	const { modes, loaded } = useNavModes()
	const { user } = useAuth()
	if (!loaded) return null
	// Публичные страницы под префиксом закрытого раздела (проверка подписи) стражу не подчиняются.
	if (publicUnderSection(pathname)) return null
	const id = sectionIdForPath(pathname)
	if (!id) return null
	if (navVisible(navMode(modes, id), isStaff(user?.role))) return null
	return <Navigate to="/bots" replace />
}
